import React from 'react';
import Plugin, { PluginProps } from '../Plugin';
import {
  TableContainer,
  TableCaption,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react';

const TablePlugin = (props: PluginProps) => {
  const contentData = props.content.data;
  const tableDataRaw = contentData.table_data;
  let tableData = [];
  try {
    tableData = JSON.parse(tableDataRaw);
  } catch (e) {}

  return (
    <TableContainer whiteSpace="unset">
      <Table variant="striped">
        <TableCaption>{contentData.name || ''}</TableCaption>
        <Thead>
          <Tr>
            {tableData[0]?.map((v: any, i: number) => (
              <Th key={i}>
                <span style={{ fontSize: '20px' }}>{v}</span>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {tableData.map((rowData: any, i: number) => {
            if (i === 0) {
              return null;
            }
            return (
              <Tr key={i}>
                {rowData.map((cellValue: any, j: number) => (
                  <Td key={j}>{cellValue}</Td>
                ))}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default TablePlugin;
